import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations, useTexture } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import useGame from '../stores/useGame'
import * as THREE from 'three'

export function BPTModule(props) {

    const group = useRef()
    const { nodes, materials, animations } = useGLTF('/BPT_Module.glb')
    const { actions } = useAnimations(animations, group)
    const thruster = useGame((state) => state.thruster)

    const hetAO = useTexture('./textures/BPT_Thruster_AO.webp')
      hetAO.flipY = false
      materials.BIPROP_Thruster.aoMap = hetAO
      materials.BIPROP_Thruster.aoMapIntensity = 1

    const state = useThree()
    const phase = useGame((state) => state.phase)

    const highlight = useGame((state) => state.highlight)

    const highlightMaterial = new THREE.MeshStandardMaterial({
      color: 'red',
      emissive: 'red',
      emissiveIntensity: 0.25,
      })


  useEffect(() => {
  if(state.size.width > 950)

    {
        if (highlight === 'h_ps') { state.scene.traverse(obj => { if(obj.name.includes('S_PS')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_fd') { state.scene.traverse(obj => { if(obj.name.includes('S_FD')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_pr') { state.scene.traverse(obj => { if(obj.name.includes('S_PR')) { obj.material = highlightMaterial } }) }
        
        if (highlight === 'null') 
            {
            state.scene.traverse(obj => {

                if(obj.name.includes('BPT_S_PS') | obj.name.includes('BPT_S_FD') | obj.name.includes('BPT_S_PR'))
                {
                    obj.material = materials.BIPROP_Thruster
                }
            })
            }
    }
  },[highlight])

  useEffect(() => {
      if (phase === 'zoomed') 
          {
              actions['BPT_Animation'].loop = false
              actions['BPT_Animation'].clampWhenFinished = true
              actions['BPT_Animation'].timeScale = 1
              actions['BPT_Animation'].repetitions = 0
              actions['BPT_Animation'].paused = false
              actions['BPT_Animation'].play()
          }
  
      if (phase != 'zoomed') 
          {
              actions['BPT_Animation'].loop = false
              actions['BPT_Animation'].clampWhenFinished = true
              actions['BPT_Animation'].timeScale = -1
              actions['BPT_Animation'].repetitions = 0
              actions['BPT_Animation'].paused = false
              actions['BPT_Animation'].play()
          }
    }, [phase, actions])

  return (
   <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="BPT_Animator">
          <group name="BPT_POI_C_CP" position={[0.491, 0.086, -0.021]} />
          <group name="BPT_POI_C_FD1" position={[0.508, -0.099, -0.092]} />
          <group name="BPT_POI_C_FD2" position={[0.508, 0.102, 0]} />
          <group name="BPT_POI_C_IV1" position={[0.484, -0.092, -0.051]} />
          <group name="BPT_POI_C_IV2" position={[0.484, 0.095, -0.049]} />
          <group name="BPT_POI_C_NZ" position={[0.506, 0.015, 0]} />
          <group name="BPT_POI_C_PR1" position={[0.491, -0.102, -0.024]} />
          <group name="BPT_POI_C_PR2" position={[0.491, 0.11, -0.075]} />
          <group name="BPT_POI_C_SF1" position={[0.491, -0.075, -0.024]} />
          <group name="BPT_POI_C_SF2" position={[0.491, 0.073, -0.075]} />
          <group name="BPT_POI_C_SS" position={[0.488, -0.039, 0]} />
          <group name="BPT_POI_C_TO" position={[0.487, 0, -0.006]} />
          <group name="BPT_POI_S_FD" position={[0.485, 0, -0.001]} />
          <group name="BPT_POI_S_PR" position={[0.491, 0.09, 0]} />
          <group name="BPT_POI_S_PS" position={[0.446, -0.05, -0.06]} />

          <group name="BPT_POS_C_CP" position={[0.443, 0.086, -0.021]} />
          <group name="BPT_POS_C_FD1" position={[0.443, -0.099, -0.108]} />
          <group name="BPT_POS_C_FD2" position={[0.452, 0.108, 0]} />
          <group name="BPT_POS_C_IV1" position={[0.446, -0.103, -0.051]} />
          <group name="BPT_POS_C_IV2" position={[0.449, 0.101, -0.049]} />
          <group name="BPT_POS_C_NZ" position={[0.585, 0.033, -0.048]} />
          <group name="BPT_POS_C_PR1" position={[0.444, -0.118, -0.024]} />
          <group name="BPT_POS_C_PR2" position={[0.458, 0.117, -0.074]} />
          <group name="BPT_POS_C_SF1" position={[0.451, -0.074, -0.002]} />
          <group name="BPT_POS_C_SF2" position={[0.448, 0.074, -0.089]} />
          <group name="BPT_POS_C_SS" position={[0.432, -0.039, 0]} />
          <group name="BPT_POS_C_TO" position={[0.432, 0.03, 0]} />
          <group name="BPT_POS_S_FD" position={[0.416, -0.001, 0]} />
          <group name="BPT_POS_S_PR" position={[0.417, 0.092, -0.08]} />
          <group name="BPT_POS_S_PS" position={[0.416, -0.093, -0.077]} />

          <group name="BPT_TAR_C_CP" position={[0.491, 0.091, -0.022]} />
          <group name="BPT_TAR_C_FD1" position={[0.508, -0.089, -0.092]} />
          <group name="BPT_TAR_C_FD2" position={[0.508, 0.089, 0]} />
          <group name="BPT_TAR_C_IV1" position={[0.484, -0.089, -0.052]} />
          <group name="BPT_TAR_C_IV2" position={[0.484, 0.09, -0.049]} />
          <group name="BPT_TAR_C_NZ" position={[0.552, 0.003, 0]} />
          <group name="BPT_TAR_C_PR1" position={[0.491, -0.096, -0.024]} />
          <group name="BPT_TAR_C_PR2" position={[0.487, 0.105, -0.075]} />
          <group name="BPT_TAR_C_SF1" position={[0.491, -0.075, -0.024]} />
          <group name="BPT_TAR_C_SF2" position={[0.474, 0.073, -0.075]} />
          <group name="BPT_TAR_C_SS" position={[0.488, -0.039, 0]} />
          <group name="BPT_TAR_C_TO" position={[0.487, 0, -0.006]} />
          <group name="BPT_TAR_S_FD" position={[0.497, -0.021, 0]} />
          <group name="BPT_TAR_S_PR" position={[0.492, 0.09, -0.052]} />
          <group name="BPT_TAR_S_PS" position={[0.481, -0.089, -0.054]} />
         
         {thruster === 'BPT' && <> 
          <mesh
            name="BPT_C_Backplate"
            castShadow
            receiveShadow
            geometry={nodes.BPT_C_Backplate.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.518, 0, 0]}
          />
          <mesh
            name="BPT_C_Bolts"
            castShadow
            receiveShadow
            geometry={nodes.BPT_C_Bolts.geometry}
            material={materials.BIPROP_Thruster}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_C_PowerCable"
            castShadow
            receiveShadow
            geometry={nodes.BPT_C_PowerCable.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.499, -0.051, 0.055]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_FD_C_Box"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_FD_C_Box.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.497, -0.054, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_FD_C_TO"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_FD_C_TO.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.49, 0, -0.005]}
            rotation={[0, Math.PI / 3, -Math.PI]}
          />
          <mesh
            name="BPT_S_FD_C_NZ"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_FD_C_NZ.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.525, 0, 0]}
            rotation={[0, 0, Math.PI / 2]}
          />
          <mesh
            name="BPT_S_FD_C_SS_Red"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_FD_C_SS_Red.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.479, -0.019, 0]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="BPT_S_FD_C_ThrustPlate"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_FD_C_ThrustPlate.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.508, 0, 0]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_PR_C_CP"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_CP.geometry}
            material={materials.BIPROP_Thruster}
          />
          <mesh
            name="BPT_S_PR_C_FD2"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_FD2.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.519, 0.09, 0]}
          />
          <mesh
            name="BPT_S_PR_C_IV2"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_IV2.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.492, 0.09, 0.037]}
          />
          <mesh
            name="BPT_S_PR_C_Join_Fuel"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_Join_Fuel.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.487, 0.091, -0.075]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="BPT_S_PR_C_Join_Oxi"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_Join_Oxi.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.487, 0.091, 0.074]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="BPT_S_PR_C_Join_Pressure"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_Join_Pressure.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.488, 0.09, 0]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_PR_C_Pipes_Pressure"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_Pipes_Pressure.geometry}
            material={materials.BIPROP_Thruster}
            position={[0, -0.011, 0]}
          />
          <mesh
            name="BPT_S_PR_C_PR2"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_PR2.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.491, 0.097, 0]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_PR_C_SF2"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_SF2.geometry}
            material={materials.BIPROP_Thruster}
          />
          <mesh
            name="BPT_S_PR_C_Tank_Pressure"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PR_C_Tank_Pressure.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.49, 0.048, 0]}
            rotation={[Math.PI, 0, 0]}
          />
          <mesh
            name="BPT_S_PS_C_FD1"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_FD1.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.519, -0.089, 0]}
          />
          <mesh
            name="BPT_S_PS_C_IV1"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_IV1.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.492, -0.089, 0.037]}
          />
          <mesh
            name="BPT_S_PS_C_Join_1_Fuel"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Join_1_Fuel.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.491, -0.089, -0.024]}
          />
          <mesh
            name="BPT_S_PS_C_Join_1_Oxi"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Join_1_Oxi.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.491, -0.089, 0.024]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_PS_C_Join_Prop_Fuel"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Join_Prop_Fuel.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.49, -0.089, -0.074]}
          />
          <mesh
            name="BPT_S_PS_C_Join_Prop_Oxi"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Join_Prop_Oxi.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.49, -0.089, 0.074]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="BPT_S_PS_C_Pipes_Fuel"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Pipes_Fuel.geometry}
            material={materials.BIPROP_Thruster}
            position={[0, -0.01, 0]}
          />
          <mesh
            name="BPT_S_PS_C_Pipes_Oxi"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Pipes_Oxi.geometry}
            material={materials.BIPROP_Thruster}
            position={[0, -0.01, 0]}
          />
          <mesh
            name="BPT_S_PS_C_PR1"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_PR1.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.491, -0.096, -0.051]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            name="BPT_S_PS_C_SF1"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_SF1.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.495, -0.104, 0]}
          />
          <mesh
            name="BPT_S_PS_C_Tank_Fuel"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Tank_Fuel.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.477, 0.015, -0.075]}
          />
          <mesh
            name="BPT_S_PS_C_Tank_Oxi"
            castShadow
            receiveShadow
            geometry={nodes.BPT_S_PS_C_Tank_Oxi.geometry}
            material={materials.BIPROP_Thruster}
            position={[0.477, 0.015, 0.075]}
          /></>}
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/BPT_Module.glb')
